export default __webpack_public_path__ + "static/media/Bulma-Logo.ecefb4da.svg";